module.exports = __webpack_public_path__ + "img/image12.16522130.png";